module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/carousel_03@2x.56142b8.png";